import { render, staticRenderFns } from "./purchaseCheque.vue?vue&type=template&id=62f0679e"
import script from "./purchaseCheque.vue?vue&type=script&lang=js"
export * from "./purchaseCheque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports